import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";

export const SUPPORTED_LANGS = ["en", "es"];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
        },
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LANGS,
        nonExplicitSupportedLngs: true, // es-MX -> es
        load: "languageOnly",
        interpolation: { escapeValue: false },
        detection: {
            // querystring (?lang=es) wins, then prior choice, then the browser
            order: ["querystring", "localStorage", "navigator", "htmlTag"],
            lookupQuerystring: "lang",
            lookupLocalStorage: "cf_lang",
            caches: ["localStorage"],
        },
        react: { useSuspense: false },
    });

// Keep <html lang> in sync for SEO + accessibility, and notify listeners
// (SEOHead, etc.) so meta/schema can re-localize on a runtime language switch.
const applyHtmlLang = (lng) => {
    if (typeof document !== "undefined") {
        document.documentElement.lang = (lng || "en").split("-")[0];
        try { window.dispatchEvent(new Event("languageChanged")); } catch { /* noop */ }
    }
};
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

// NOTE: We intentionally rely ONLY on i18next's built-in LanguageDetector
// (order: querystring -> localStorage -> navigator) for language selection.
// A previous custom block force-switched an already-resolved English session
// to Spanish on every load whenever navigator.language started with "es",
// which overrode the user's effective/cached EN choice and caused a jarring
// EN->ES flip. The detector already auto-detects Spanish browsers on first
// visit, so first-time Spanish visitors still get Spanish — but a stored EN
// (or explicit EN toggle) is now respected and never overridden.

export default i18n;
